import { render, staticRenderFns } from "./_ExtraMenuElement.vue?vue&type=template&id=bb7edaa0&"
import script from "./_ExtraMenuElement.vue?vue&type=script&lang=js&"
export * from "./_ExtraMenuElement.vue?vue&type=script&lang=js&"
import style0 from "./_ExtraMenuElement.vue?vue&type=style&index=0&id=bb7edaa0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports